import { render, staticRenderFns } from "./InstagramIconParts.vue?vue&type=template&id=7219058e&scoped=true"
import script from "./InstagramIconParts.vue?vue&type=script&lang=ts"
export * from "./InstagramIconParts.vue?vue&type=script&lang=ts"
import style0 from "./InstagramIconParts.vue?vue&type=style&index=0&id=7219058e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7219058e",
  null
  
)

export default component.exports